import React from 'react';
import CampaignTable from './CampaignTable';
import OfferProvider from '../offer/context';
import CampaignProvider from './context';

const Campaign: React.FC = () => {
  return (
    <OfferProvider>
      <CampaignProvider>
        <CampaignTable />
      </CampaignProvider>
    </OfferProvider>
  );
};

export default Campaign;
